import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axiosConfig';
import { showSuccessToast, showErrorAlert } from '../utils/alert';
import './LoginPage.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/api/users/forgot-password', { email });
      showSuccessToast('Silakan cek email Anda untuk instruksi selanjutnya.');
      navigate('/reset-password', { state: { userId: data.userId } });
    } catch (error) {
      showErrorAlert(error.response?.data?.message || 'Terjadi kesalahan.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <form className="login-form-card" onSubmit={handleSubmit}>
      <div className="login-header"><h1 className="login-title">Lupa Password</h1></div>
        <div className="form-group"><label>Alamat Email</label><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
        <button type="submit" className="login-button" disabled={loading}>{loading ? 'Mengirim...' : 'Reset Password'}</button>
        <p><Link to="/login">Kembali ke Login</Link></p>
      </form>
    </div>
  );
};

export default ForgotPasswordPage;